import { render, staticRenderFns } from "./twitter.vue?vue&type=template&id=77280f12"
import script from "./twitter.vue?vue&type=script&lang=js"
export * from "./twitter.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports